import {
  SingleProcedureRepository,
  ProcedureId,
  Procedure,
  ProcedureNotFoundError,
  ProcedureFactory
} from '@/Domain/Procedures'
import store from '@/Infrastructure/Store'
import { VuexProcedureData } from './VuexProcedureData'

export class VuexSingleProcedureRepository implements SingleProcedureRepository {
  private _factory: ProcedureFactory<VuexProcedureData>

  constructor (factory: ProcedureFactory<VuexProcedureData>) {
    this._factory = factory
  }

  byId (procedureId: ProcedureId): Promise<Procedure> {
    const storedProcedure = store.getters['procedure/currentProcedure']
    try {
      if (!storedProcedure || storedProcedure.procedureId !== procedureId.id) {
        return Promise.reject(new ProcedureNotFoundError(`Procedure ${procedureId.id} not found`))
      }
      const procedure = this._factory.makeProcedure(storedProcedure)
      return Promise.resolve(procedure)
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
